var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Question_Mark",
    "data-name": "Icon Question Mark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 10,
    height: 10,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M5,0a5,5,0,1,0,5,5A5.015,5.015,0,0,0,5,0ZM4.95,8.3a.7.7,0,1,1,.7-.7A.684.684,0,0,1,4.95,8.3ZM6.3,4.4,5.75,5a.611.611,0,0,0-.2.45.608.608,0,0,1-.6.6.578.578,0,0,1-.6-.6,1.116,1.116,0,0,1,.4-.9L5.2,4a1.135,1.135,0,0,0,.35-.7A.525.525,0,0,0,5,2.75a.588.588,0,0,0-.6.45.653.653,0,0,1-.6.35A.525.525,0,0,1,3.25,3a.544.544,0,0,1,.05-.25A1.666,1.666,0,0,1,5,1.7,1.62,1.62,0,0,1,6.75,3.3,1.64,1.64,0,0,1,6.3,4.4Z",
    fill: "#00147b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/Question_Mark_Icon.5c83bf980d388e4bc032a19af981bc06.svg";
export { ForwardRef as ReactComponent };